import React, { useState } from "react";
import Button from "./Button";
import CocktailArticle from "./CocktailArticle";

const Cocktail = ({ cocktails }) => {
  const [cocktail, setCocktail] = useState(cocktails);
  const FilterCategory = (category) => {
    if (category === "all") {
      setCocktail(cocktails);
    } else {
      const FilterNewCategory = cocktails.filter(
        (singCock) => singCock.category === category
      );
      setCocktail(FilterNewCategory);
    }
  };
  const allCategories = [
    "all",
    ...new Set(cocktails.map((coc) => coc.category)),
  ];

  // this variable for conditionally checking the length of "cocktail" state and slicing it according it's length
  const sliceCocktail = cocktail?.length === 25 ? cocktail?.slice(0,24):cocktail?.length > 21 && cocktail?.length < 24 ? cocktail?.slice(0,21):cocktail.length > 18 && cocktail.length < 21 ? cocktail.slice(0,18):cocktail.length > 15 && cocktail.length < 18 ? cocktail.slice(0, 15):cocktail.length > 12 && cocktail.length < 15 ? cocktail.slice(0,12):cocktail.length > 9 && cocktail.length < 12 ? cocktail.slice(0,9):cocktail.length > 6 && cocktail.length < 9 ? cocktail.slice(0,6):cocktail.length > 3 && cocktail.length < 6 ? cocktail.slice(0,3):cocktail.length > 0 && cocktail.length <= 3 ? cocktail.slice(0,3):cocktail;

  // console.log(sliceCocktail);
  // console.log(cocktail)
  return (
    <div>
      <section className=" btn-src-flex">
      <Button FilterCategory={FilterCategory} allCategories={allCategories} />
      </section>
      {/* <h1 className="h1-cocktail text-[white!important] text-[25px]">Cocktails</h1> */}
      <section className="cocktails-list-flex">
        {sliceCocktail?.map((singleCocktail) => (
          <CocktailArticle key={singleCocktail.id} {...singleCocktail} />
        ))}
      </section>
    </div>
  );
};

export default Cocktail;
